module.exports = "/images/creditCardBrands.png?422f315b2d0c7d4579919eec2284afa0";